<template>
  <div class="community-section__app">

    <div class="community-section__app_filters_header">
      <h3>{{ translations?.filters }}</h3>

      <!-- Filters toggle button for mobile. -->
      <button class="d-lg-none mb-2 caret-button" @click="isNavCollapsed = !isNavCollapsed"
        :class="{ 'rotated': !isNavCollapsed }">
      </button>
    </div>

    <nav class="community-section__app_filters">
      <ul class="custom_nav category-nav" :class="{ 'collapse': isNavCollapsed }">
        <li>
          <div class="input field-dropdown">
            <div class="select-wrapper">
              <label for="select_news_type">{{ translations?.newsType }}</label>
              <select ref="newsTypeSelect" id="select_news_type" v-model="selectedType" @change="applyFilters">
                <option value="none" selected="">{{ translations?.selectNewstype }}</option>
                <option :value="newsType.slug" v-for="newsType in types" :key="newsType.slug">{{
                  newsType.title }}</option>
              </select>
            </div>
          </div>
        </li>

        <li>
          <div class="input field-dropdown">
            <div class="select-wrapper">
              <label for="select_topic">{{ translations?.topic }}</label>
              <select ref="topicSelect" id="select_topic" v-model="selectedTopic" @change="applyFilters"></select>
            </div>
          </div>
        </li>

        <li v-if="selectedTopic !== 'none' || selectedType !== 'none'" class="clear-btn">
          <div class="input field-dropdown">
            <button class="btn btn-secondary community-btn clear-btn" @click="clearFilters">
              Clear
            </button>
          </div>
        </li>

      </ul>
    </nav>

    <div class="community-section__app_posts" v-show="!showLoader">

      <div class="community-section__app_posts_elts" v-if="communityList.length > 0">

        <div class="community-section__app_col" v-for="post in communityList" :key="post.title">

          <div class="community-section__app_posts_elt">

            <a :href="`${post?.uri}`" class="community-section__app_posts_elt_post">

              <figure v-if="post?.photo" class="community-section__app_posts_elt_post_image">
                <img :src="post.photo" :alt="post.photoAlt" class="img-fluid">
              </figure>

              <div class="community-section__app_posts_elt_post_info">
                <p class="community-section__app_posts_elt_post_info_heading">
                  <span v-if="post?.date">
                    {{ post.date }}
                  </span>
                  <span v-if="post?.newsTypes[0]?.title">
                    {{ post?.newsTypes[0]?.title }}
                  </span>
                </p>
                <h4 v-if="post?.title" class="community-section__app_posts_elt_post_info_title">
                  {{ post.title }}
                </h4>
                <div v-if="post?.body" class="community-section__app_posts_elt_post_info_body"
                  v-html="excerpt(post.body)">
                </div>
                <p v-if="post?.author" class="community-section__app_posts_elt_post_info_authors">
                  {{ post.author }}
                </p>
              </div>
            </a>
          </div>

        </div>
      </div>

      <div class="community-section__app_nomatch" v-else>
        <p v-if="isInitialLoad">Loading news...</p>
        <div v-else>
          <p><span class="nomatch_icon"></span>No Results Found</p>
          <span>There are no results that match those filters.</span>
        </div>
      </div>

      <div class="row load-more-wrapper">
        <button class="btn btn-secondary community-btn" @click="loadMorePosts" :disabled="isLoading"
          v-if="showLoadMoreBtn && communityList.length > 0">
          {{ isLoading ? 'Loading...' : 'LOAD MORE POSTS' }}
        </button>
      </div>

    </div>

    <div v-show="showLoader">
      <transition name="loadingFade">
        <div id="loading">
          <div>
            <div class="loader-wheel">
              <i>
                <i>
                  <i>
                    <i>
                      <i>
                        <i>
                          <i>
                            <i>
                              <i>
                                <i>
                                  <i>
                                    <i></i>
                                  </i>
                                </i>
                              </i>
                            </i>
                          </i>
                        </i>
                      </i>
                    </i>
                  </i>
                </i>
              </i>
            </div>
            <h4>Loading</h4>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {

  data() {
    return {
      communityList: [],
      communityLimit: 9,
      showLoadMoreBtn: true,
      selectedTopic: 'none',
      selectedType: 'none',
      isLoading: false,
      showLoader: false,
      isInitialLoad: true,
      isNavCollapsed: true,
      newsTypeChoices: null,
      topicChoices: null,
    }
  },

  props: ['communities', 'categories', 'types', 'loading', 'translations'],

  methods: {

    applyFilters() {
      // Reset the posts limit when filters are applied.
      this.communityLimit = 9;
      this.showLoader = true;
      this.loadPosts();
    },

    loadPosts(paginated = false) {
      this.isLoading = true; // Set loading state.

      const url = document.body.getAttribute('data-base-url');
      const params = new URLSearchParams();

      if (this.selectedTopic !== 'none') params.append('topic', this.selectedTopic);
      if (this.selectedType !== 'none') params.append('type', this.selectedType);
      params.append('limit', this.communityLimit);
      if (paginated) {
        params.append('offset', this.communityList.length);
      }

      axios.get(`${url}community/community.json?${params.toString()}`)
        .then(response => {
          let posts = response.data.communities;
          if (paginated) {
            this.communityList = this.communityList.concat(posts);
          } else {
            this.communityList = posts;
          }

          // If the number of loaded posts is less than the limit, hide the "Load More" button.
          this.showLoadMoreBtn = posts.length >= this.communityLimit;
        })
        .catch(error => {
          console.error('Error loading post:', error);
        })
        .finally(() => {
          // Reset loading states.
          this.isLoading = false;
          this.showLoader = false;

          if (this.isInitialLoad) {
            this.isInitialLoad = false;
          }
        });
    },

    loadMorePosts() {
      // Increase the post limit to load more entries.
      this.communityLimit += 9;
      this.loadPosts(true);
    },

    clearFilters() {
      this.selectedTopic = 'none';
      this.selectedType = 'none';
      this.communityLimit = 9;
      this.loadPosts();
    },

    excerpt(text, length = 150) {
      if (!text) return '';
      if (text.length <= length) return text;
      return text.substring(0, length) + '...';
    },

    initializeChoices() {
      if (this.newsTypeChoices) {
        this.newsTypeChoices.destroy();
      }
      if (this.topicChoices) {
        this.topicChoices.destroy();
      }

      const newsTypeSelect = this.$refs.newsTypeSelect;
      const topicSelect = this.$refs.topicSelect;

      if (newsTypeSelect) {
        this.newsTypeChoices = new Choices(newsTypeSelect, {
          searchEnabled: false,
          itemSelectText: '',
          shouldSort: false,
        });
      }
      if (topicSelect) {
        const choicesData = [
          { value: 'none', label: this.translations?.selectTopic }
        ].concat(
          this.categories.map(topic => ({
            value: topic.slug,
            label: topic.icon
              ? `<img src="${topic.icon}" alt="${topic.title}" class="choice-icon" />${topic.title}`
              : topic.title,
            id: topic.slug
          }))
        );

        this.topicChoices = new Choices(topicSelect, {
          allowHTML: true,
          choices: choicesData,
          searchEnabled: false,
          itemSelectText: '',
          shouldSort: false,
        });

        // Set initial value in Choices.js.
        this.topicChoices.setChoiceByValue(this.selectedTopic);

        // Sync Vue model with Choices.js changes.
        topicSelect.addEventListener('change', (event) => {
          this.selectedTopic = event.target.value;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        });
      }
    },

    destroyChoices() {
      if (this.newsTypeChoices) {
        this.newsTypeChoices.destroy();
      }
      if (this.topicChoices) {
        this.topicChoices.destroy();
      }
    },
  },

  created() {
    // Initially load the community list posts with no filters.
    this.loadPosts();
  },

  mounted() {
    this.initializeChoices();
    // If the initial loaded batch is less than the communityLimit, hide the Load More button.
    if (this.communityList.length < this.communityLimit) {
      this.showLoadMoreBtn = false;
    }
  },

  updated() {
    this.initializeChoices();
  },

  beforeUnmount() {
    this.destroyChoices();
  },
}
</script>
